/* eslint-disable no-unused-expressions */
export default (value, width, height, aspectRatio) => {
  if (!value) return '';
  const params = [];
  width ? params.push(`width=${width}`) : '';
  height ? params.push(`height=${height}`) : '';
  aspectRatio ? params.push('resize=true') : '';
  return `${value}?${params.join('&')}`;
};



// WEBPACK FOOTER //
// ./src/filter/resize-image.js